import React, { Component } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import Tooltip from '@mui/material/Tooltip';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';
//import { Link } from 'react-router-dom';
//import CustomerInfoEdit from './CustomerInfoEditComponent';
//import CustomerInfoDisp from './CustomerInfoDispComponent';
import Fab from '@mui/material/Fab';
import { Modal, Row, Col, ModalHeader, ModalFooter, Button, ModalBody } from 'reactstrap';
import MuiButton from '@mui/material/Button';
import './Css/Line.css';
// import LineRightTextComponent from './LineRightTextComponent';
// import LineRightImgComponent from './LineRightImgComponent';
// import LineRightType1Component from './LineRightType1Component';
// import LineRightType2Component from './LineRightType2Component';
// import LineRightType3Component from './LineRightType3Component';
// import LineRightType4Component from './LineRightType4Component';
// import LineRightType5Component from './LineRightType5Component';
// import LineLeftTextComponent from './LineLeftTextComponent';
// import LineLeftImgComponent from './LineLeftImgComponent';
// import LineTimeComponent from './LineTimeComponent';
import LineFormComponent from './LineFormComponent';
import throttle from 'lodash.throttle';
import * as Line from './Saga/Line';
import LineDispComponent from './LineDispComponent';
import Dropzone from 'react-dropzone';
import Grid from '../StockRooms/Grid';
import {Card, CardHeader, CardTitle, CardContent } from '@mui/material';
import * as Firebase from '../../Store/Firebase';
import * as IntroductionListEdit from '../MapMypage/Saga/MapMypage';
import * as Responses from '../ResponseDetail/Saga/Responses';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import makeStyles from '@mui/styles/makeStyles';
import { Radio, RadioGroup } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PublishIcon from '@mui/icons-material/Publish';
import PageviewIcon from '@mui/icons-material/Pageview';
import Box from '@mui/material/Box';
import ArticleIcon from '@mui/icons-material/Article';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import VideocamIcon from '@mui/icons-material/Videocam';
import moment from 'moment'

// function separate(num) {
//     // 文字列にする
//     num = String(num);

//     var len = num.length;

//     // 再帰的に呼び出すよ
//     if (len > 3) {
//         // 前半を引数に再帰呼び出し + 後半3桁
//         return separate(num.substring(0, len - 3)) + ',' + num.substring(len - 3);
//     } else {
//         return num;
//     }
// }

// const useStyles = makeStyles(theme => ({
//     absolute: {
//       backgroundColor: theme.palette.common.red,
//       // position: 'absolute',
//     //   bottom: theme.spacing(2),
//     //   right: theme.spacing(3),
//     },
//   }));

  // const classes = useStyles();

class Lines extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mode: '1',
            messages: [],
            messages2: {},
            scrollTop: 0,
            old_id: 0,
            back_date: "",
            take: 20,
            // top: this.props.lines[0].id,
            modal_send: 0,

            base64: null,
            mimeType: null,

            tooltipOpen: 0,
            webVideoCallTooltipOpen: false,
            webVideoCallDirty: false,
            mypage_id: 0,

            row: 1,

            application_remarks: "",
        };
        console.log(this.props.lines)
        // this.props.lines.map(){
        //     this.Print()
        // }
        //
        this.send = this.send.bind(this);
        this.send_mypage_url = this.send_mypage_url.bind(this);
        this.send_video_url = this.send_video_url.bind(this);
        this.confirm_send_video_url = this.confirm_send_video_url.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.lineopen = this.lineopen.bind(this);
        this.toggle_send = this.toggle_send.bind(this);
        this.togglesheet = this.togglesheet.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.mypageOpen = this.mypageOpen.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onChange = this.onChange.bind(this);
        this.OnChangeApplication = this.OnChangeApplication.bind(this);
        this.open_web_video_call_window = this.open_web_video_call_window.bind(this);
        this.onChangeWebVideoCallForm = this.onChangeWebVideoCallForm.bind(this);
        this.save_web_video_call_reservations = this.save_web_video_call_reservations.bind(this);
        this.create_web_video_call_reservations = this.create_web_video_call_reservations.bind(this);
        // this.props.get_fire_line_detail()
        // this.line_looked = this.line_looked.bind(this);



        // var result = props.lines.map(function( value ) {

        //         // alert()
        //     return this.Print(value)

        //     //配列の各要素を2倍にする
        //     // return value * 2;

        // });
    }






    // }


    async componentDidMount() {
        console.log(this.props)

        if (this.node != null && this.props.line_bottom === true) {

            this.node.scrollTop = this.node.scrollHeight;
            this.props.change_line_bottom(false);
        }
    }
    componentDidUpdate() {
        // alert(this.props.line_bottom)
        // alert(this.props.line_bottom)
        if (this.node != null && this.props.line_bottom === true) {
            // alert(this.node.scrollHeight)
            this.node.scrollTop = this.node.scrollHeight;
            this.props.change_line_bottom(false);
        }

    }


    send(value) {
        // alert(this.props.line_user_details.id)
        this.props.send_message({ replytoken: "globalcenter", message_type: "text", message_text: value.message, line_user_id: this.props.line_user_details.line_user_id, line_account_section_id: this.props.line_user_details.line_account_section_id, rent_response_id: this.props.responsedetail.id })

    }

    send_mypage_url() {

        let text = "https://rooms.global-center.co.jp/rent/" + this.props.responsedetail.response_code + "/" + this.state.mypage_id + "/"
        this.props.send_mypage({ replytoken: "globalcenter", message_type: "text", message_text: text, line_user_id: this.props.line_user_details.line_user_id, line_account_section_id: this.props.line_user_details.line_account_section_id, rent_response_id: this.props.responsedetail.id })

    }

    send_video_url() {

        let text = this.get_web_video_call_url()
        this.props.send_video({ replytoken: "globalcenter", message_type: "text", message_text: text, line_user_id: this.props.line_user_details.line_user_id, line_account_section_id: this.props.line_user_details.line_account_section_id, rent_response_id: this.props.responsedetail.id })

    }

    confirm_send_video_url() {
        if (!this.get_web_video_call_url()) {
            return
        }

        if (window.confirm("ビデオ通話URLを送信します。よろしいですか？")) {
            this.send_video_url()
            this.toggle_send(0)
        }
    }

    send_application_url() {

        let text = this.state.application_remarks
        this.props.send_application_form(
            { 
                replytoken: "globalcenter", 
                message_type: "text", 
                message_text: text, 
                line_user_id: this.props.line_user_details.line_user_id, 
                line_account_section_id: this.props.line_user_details.line_account_section_id, 
                rent_response_id: this.props.responsedetail.id,


                application_form_url: "https://rent.global-center.co.jp/mypage/apply/"+this.props.responsedetail.contract_code,
                application_password: this.props.responsedetail.application_password_contract,
                application_limit_at: this.props.responsedetail.application_limit_at_contract,
            })

    }

    send_transfer_url() {

        let text = this.state.application_remarks
        this.props.send_transfer_form(
            { 
                replytoken: "globalcenter", 
                message_type: "text", 
                message_text: text, 
                line_user_id: this.props.line_user_details.line_user_id, 
                line_account_section_id: this.props.line_user_details.line_account_section_id, 
                rent_response_id: this.props.responsedetail.id,

                application_form_url: "https://rooms.global-center.co.jp/transfer/confirm/"+this.props.responsedetail.contract_code,
                application_password: this.props.responsedetail.application_password_contract,
            })

    }

    formatWebVideoCallDateTimeLocal(value) {
        if (!value) {
            return ""
        }

        if (typeof value === "string") {
            const matched = value.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/)
            if (matched) {
                return `${matched[1]}T${matched[2]}`
            }
        }

        const parsed = moment.tz(value, [
                "YYYY-MM-DD HH:mm:ss.SSS",
                "YYYY-MM-DD HH:mm:ss",
                "YYYY-MM-DD HH:mm",
                "YYYY-MM-DDTHH:mm:ss.SSS",
                "YYYY-MM-DDTHH:mm:ss",
                "YYYY-MM-DDTHH:mm",
                "YYYY/MM/DD HH:mm:ss",
                "YYYY/MM/DD HH:mm",
            ], "Asia/Tokyo")

        return parsed.isValid() ? parsed.format("YYYY-MM-DDTHH:mm") : ""
    }

    buildWebVideoCallForm(reservation) {
        const value = reservation || {}
        return {
            id: value.id || "",
            uuid: value.uuid || value.web_video_call_reservation_uuid || "",
            topic: value.topic || "",
            reservation_at: this.formatWebVideoCallDateTimeLocal(value.reservation_at),
            limited_at: this.formatWebVideoCallDateTimeLocal(value.limited_at),
            start_at: this.formatWebVideoCallDateTimeLocal(value.start_at),
            end_at: this.formatWebVideoCallDateTimeLocal(value.end_at),
            remarks: value.remarks || "",
            rent_contract_id: value.rent_contract_id || "",
            rent_response_id: value.rent_response_id || this.props.responsedetail.id || "",
        }
    }


    lineopen() {

        this.props.get_line_open({ line_user_id: this.props.line_user_details.line_user_id, line_account_section_id: this.props.line_user_details.line_account_section_id, take: 20 })
    }


    toggle_send(nom) {

        this.setState({
            // modal_send: nom,
            base64: null,
            name: null,
            mimeType: null,

            application_remarks:"",
            webVideoCallDirty: false,
        })
        this.props.change_line_file_data(null)
        this.props.change_line_send_modal(nom)

        if(nom == 3){//マイページ
            this.props.get_rent_introduction_headers_list(this.props.responsedetail.id)
        }else if(nom == 4){//申込フォーム
            this.setState({
                application_remarks:"この度は弊社 株式会社グローバルセンターにて賃貸物件のお申込みを頂き誠にありがとうございます。\nお客様のお申込み用ページをお送りいたします。"
            })
        }else if(nom == 5){//振替
            this.setState({
                application_remarks:"この度は弊社 株式会社グローバルセンターにて賃貸物件をご契約頂き誠にありがとうございます。\n口座振替受付サービスのお申込みページをお送りいたします。\n\n手順書をご確認のうえ、内容に沿って進めていただきますようお願いいたします。"
            })
        }else if(nom == 6){//ビデオ
            this.props.get_web_video_call_reservations(this.props.responsedetail.id)
        }

        this.setState({ refresh: !this.state.refresh })
        
    }



    scrollToBottom = () => {

        if (this.node != null && this.props.line_bottom === true) {

            this.node.scrollTop = this.node.scrollHeight;


            this.props.change_line_bottom(false);
        }
    }

    togglesheet = () => {

        this.setState(prevState => ({
            modalsheet: !prevState.modalsheet,

        }));
    }

    onDrop = (files) => {
        console.log(files)
        const file = files[0]
        const reader = new FileReader()
        reader.readAsDataURL(file)
        console.log(file.type)
        reader.onload = () => {
            this.setState({
                base64: reader.result,
                name: file.name,
                mimeType: file.type
            })
            this.props.change_line_file_data({
                file: files,
                name: file.name,
                mimeType: file.type
            })
        }

        // let sendfile = [];
        // sendfile.file = files;



    };
    // line_looked() {

    //     this.props.update_line_looked()
    //     // this.togglemailtaiou()
    // }

    handleScroll = throttle((event) => {
        console.log(this.node.scrollTop)

        // console.log(this.refs[this.state.top])

        if (this.node.scrollTop === 0) {
            // alert(this.state.take)

            this.props.get_lines({ line_user_id: this.props.line_user_details.line_user_id, line_account_section_id: this.props.line_user_details.line_account_section_id, take: this.state.take + 5 })
            this.setState({ take: this.state.take + 5 })
            this.node.scrollTop = 50;


            // let token = authentication.getAccessToken();
            // alert(this.props.line_user_details.id)
            // fetch(process.env.REACT_APP_API_LINE_EX_URL + `/v1/lines/list/` + this.props.line_user_details.id + '/' + this.props.line_user_details.line_account_section_id + '/' + (this.state.take + 5), { method: 'get', headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' } })
            //     .then(response => response.json())
            //     .then(data => {

            //         console.log("かえってきたよ")
            //         console.log(data)
            //         this.setState({ lines: data })

            //         this.setState({ take: this.state.take + 5 })
            //         this.node.scrollTop = 50;
            //         // console.log(data); // `data.json()` の呼び出しで解釈された JSON データ
            //     });
            //     let ref = firebaseDb.child('line/all').orderByChild('id').startAt(this.state.old_id + 1).limitToFirst(1);

            //     ref.off()
            //     ref.on('child_added',
            //         (snapshot) => {

            //             this.Print(snapshot);

            //             this.node.scrollTop = 30;

            //         })
        }
        // this.setState({
        //     scrollTop: this.node.scrollTop
        //  })

    }, 100)

    mypageOpen = (id) => {

        window.open("https://rooms.global-center.co.jp/rent/" + this.props.responsedetail.response_code + "/" + id + "/")
    }

    url = (e) => {
        console.log(e)
        e.target.select()
        navigator.clipboard.writeText(e.target.value);
    // alert(e.target.id)
        this.setState({ tooltipOpen: e.target.id });
        this.tooltipdelete()
      }
    
    tooltipdelete = () => {
    
        setTimeout(() => {
            this.setState({ tooltipOpen: 0 });
        }, 1000)
    
      }
    onChange(e) {
        this.setState({
            mypage_id: e.target.value
        });
    }

    OnChangeApplication(e) {
        this.setState({
            application_remarks: e.target.value
        });
    }

    onChangeWebVideoCallForm(e) {
        const webVideoCallForm = {
            ...this.buildWebVideoCallForm(this.props.web_video_call_reservations),
            [e.target.name]: e.target.value
        }
        this.setState({ webVideoCallDirty: true })
        this.props.change_web_video_call_reservations(webVideoCallForm);
    }

    save_web_video_call_reservations() {
        this.setState({ webVideoCallDirty: false })
        this.props.update_web_video_call_reservations()
    }

    create_web_video_call_reservations() {
        this.setState({ webVideoCallDirty: false })
        this.props.insert_web_video_call_reservations()
    }

    get_web_video_call_uuid() {
        return this.props.web_video_call_reservations?.uuid
            || this.props.web_video_call_reservations?.web_video_call_reservation_uuid
            || this.props.contract_follow_editer?.web_video_call_reservation_uuid
            || ""
    }

    get_web_video_call_url() {
        const uuid = this.get_web_video_call_uuid()
        if (!uuid) {
            return ""
        }
        return `https://gl-communication.azurewebsites.net/Reception/${uuid}?openExternalBrowser=1`
    }

    open_web_video_call_window() {
        const url = this.get_web_video_call_url()
        if (!url) {
            return
        }
        window.open(url)
    }

    copy_web_video_call_url = (e) => {
        e.target.select()
        navigator.clipboard.writeText(e.target.value);
        this.setState({ webVideoCallTooltipOpen: true });
        setTimeout(() => {
            this.setState({ webVideoCallTooltipOpen: false });
        }, 1000)
    }
        
    render() {

        const webVideoCallUrl = this.get_web_video_call_url()
        const webVideoCallForm = this.buildWebVideoCallForm(this.props.web_video_call_reservations)

        
        return (
            <Box sx={{display: "flex", flexDirection: "column", height: "100%",}}>
                <div className="item-line" id="item-line" onScroll={this.handleScroll} ref={(node) => this.node = node} style={{ flex: 1, padding: "16px", overflow: "auto" }}>



                    {this.props.line_send_modal === 99 ? <div style={{ position: "absolute", zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "100%", height: "100%", marginLeft: -15, marginTop: -30 }}>

                        <div style={{ margin: "auto", marginTop: 50, borderRadius: "10px", width: "400px", height: "450px", padding: "20px", background: "#FFF" }}>



                            <Box sx={{display: "flex", flexWrap: "wrap"}} gap={2}>
                                <div>
                                    <IconButton onClick={() => this.toggle_send(1)} sx={{ width:"40px", height:"40px", mt:0.5 }}>
                                        <ShoppingCartIcon color="primary" fontSize='large' />
                                    </IconButton>
                                    <div style={{ fontSize: "10px", marginTop: "5px", width:"60px", textAlign:"center" }}>ｽﾄｯｸから物件送信</div>
                                </div>
                                <div>
                                    <IconButton onClick={() => this.toggle_send(2)} sx={{ width:"40px", height:"40px", mt:0.5 }}>
                                        <PublishIcon color="primary" fontSize='large' />
                                    </IconButton>
                                    <div style={{ fontSize: "10px", marginTop: "5px", width:"60px", textAlign:"center"  }}>ファイル送信</div>
                                </div>
                                <div>
                                    <IconButton onClick={() => this.toggle_send(3)} sx={{ width:"40px", height:"40px", mt:0.5 }}>
                                        <PageviewIcon color="primary" fontSize='large' />
                                    </IconButton>
                                    <div style={{ fontSize: "10px", marginTop: "5px", width:"60px", textAlign:"center"  }}>マイページ</div>
                                </div>
                                <div>
                                    <IconButton onClick={() => this.toggle_send(6)} sx={{ width:"40px", height:"40px", mt:0.5 }}>
                                        <VideocamIcon color="primary" fontSize='large' />
                                    </IconButton>
                                    <div style={{ fontSize: "10px", marginTop: "5px", width:"60px", textAlign:"center" }}>ビデオ通話</div>
                                </div>
                                <div>
                                    <IconButton
                                    disabled={!(this.props.responsedetail.contract_code && this.props.responsedetail.application_limit_at_contract && this.props.responsedetail.application_password_contract)}
                                    onClick={() => this.toggle_send(4)} sx={{ width:"40px", height:"40px", mt:0.5 }}>
                                        <ArticleIcon color={!(this.props.responsedetail.contract_code && this.props.responsedetail.application_limit_at_contract && this.props.responsedetail.application_password_contract) ? "" : "primary"} fontSize='large' />
                                    </IconButton>
                                    <div style={{ fontSize: "10px", marginTop: "5px", width:"60px", textAlign:"center"  }}>申込フォーム</div>
                                </div>
                                <div>
                                    <IconButton
                                    disabled={!(this.props.responsedetail.contract_code && this.props.responsedetail.application_password_contract)}
                                    onClick={() => this.toggle_send(5)} sx={{ width:"40px", height:"40px", mt:0.5 }}>
                                        <AccountBalanceWalletIcon color={!(this.props.responsedetail.contract_code && this.props.responsedetail.application_password_contract) ? "" : "primary"} fontSize='large' />
                                    </IconButton>
                                    <div style={{ fontSize: "10px", marginTop: "5px", width:"60px", textAlign:"center"  }}>口座振替</div>
                                </div>

                            </Box>


{/* 

                            <div className='tooltip1'>
                                <Fab color="primary" size="small" onClick={() => this.props.toggle_send(1)}>
                                    <ShoppingCartIcon />
                                </Fab>
                                <div class="description1">ｽﾄｯｸから物件送信</div>
                            </div>

                            {this.props.responsedetail.id ? 
                            <div className='tooltip1'>
                                <Fab color="secondary" size="small" onClick={() => this.props.toggle_send(2)}>
                                    <PublishIcon />
                                </Fab>
                                <div class="description1">ファイル送信</div>
                            </div>:""}
                            {this.props.responsedetail.id ? <div className='tooltip1'>
                                <Fab color="secondary" style={{backgroundColor:"#28a745"}} size="small" onClick={() => this.props.toggle_send(3)}>
                                    <PageviewIcon />
                                </Fab>
                                <div class="description1">マイページ</div>
                            </div>:""} */}



                            <Button color="secondary" style={{ margin: "20px", marginTop: "50px" }} onClick={() => this.toggle_send(0)}>キャンセル</Button>

                        </div>

                    </div> : ""
                    }


                    {this.props.line_send_modal === 1 ? <div style={{ position: "absolute", zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "100%", height: "100%", marginLeft: -15, marginTop: -30 }}>

                        <div style={{ margin: "auto", marginTop: 50, borderRadius: "10px", width: "400px", height: "450px", padding: "20px", background: "#FFF" }}>
                            LINE物件情報送信
                            <Grid />

                            <Button color="danger" style={{ margin: "20px", marginTop: "50px" }} onClick={this.props.send_line_stock_rooms} disabled={this.props.line_send_list_loading}>送信する</Button>
                            <Button color="secondary" style={{ margin: "20px", marginTop: "50px" }} onClick={() => this.toggle_send(0)}>キャンセル</Button>

                        </div>

                    </div> : ""
                    }

                    {this.props.line_send_modal === 2 ? <div style={{ position: "absolute", zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "100%", height: "100%", marginLeft: -15, marginTop: -30 }}>
                        <div style={{ margin: "auto", marginTop: 50, borderRadius: "10px", width: "400px", height: "400px", padding: "20px", background: "#FFF" }}>
                            <p>ファイル送信</p>
                            {this.state.base64 && (this.state.mimeType === "image/jpeg" || this.state.mimeType === "image/png") ? <div><img src={this.state.base64} style={{ maxWidth: 250, maxHeight: 250 }} /></div>
                                : this.state.base64 ? <div><Card style={{ padding: 5 }}><b>{this.state.name}</b> </Card></div> : <Dropzone

                                    onDrop={this.onDrop}>
                                    {({ getRootProps, getInputProps }) => (

                                        <div {...getRootProps({ className: 'dropzone' })} style={{ background: "#f5f5f5" }}>

                                            <input {...getInputProps()} />

                                            <div style={{ height: 100 }}>
                                                <p>{this.state.name ? this.state.name : "ファイル添付　クリックまたはドラッグ&ドロップ"}</p>
                                                <ul style={{ padding: 0, marginTop: 3 }}  >


                                                </ul>

                                            </div>

                                        </div>

                                    )}
                                </Dropzone>}
                            {this.state.base64 ? <Button color="danger" style={{ margin: "20px", marginTop: "50px" }} onClick={this.props.upload_line_file} disabled={this.props.line_send_file_loading}>送信する</Button> : ""}

                            <Button color="secondary" style={{ margin: "20px", marginTop: "50px" }} onClick={() => this.toggle_send(0)}>キャンセル</Button>

                        </div>
                    </div> : ""}

                    {this.props.line_send_modal === 3 ? <div style={{ position: "absolute", zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "100%", height: "100%", marginLeft: -15, marginTop: -30 }}>

                        <div className="line_mypage" style={{ margin: "auto", marginTop: 50, borderRadius: "10px", width: "400px", height: "450px", padding: "20px", background: "#FFF" }}>
                            マイページ送信

                        <Scrollbars style={{height:350, padding:3 }}>
                        <RadioGroup row aria-label="position" name="color" onChange={this.onChange} value={parseInt(this.state.mypage_id)} >
                        {this.props.rent_introduction_headers_list ? this.props.rent_introduction_headers_list.map((value, index) => {
                            return (
                                <Card style={{marginBottom:10}}>
                                    
                                    <CardContent style={{textAlign: "left"}}>
                                        <Typography gutterBottom variant="h7" component="div">
                                            <FormControlLabel control={<Radio value={parseInt(value.id)} />} label="" />
                                            {value.name}
                                            <IconButton color="primary" onClick={() => this.mypageOpen(value.id)} size="large">
                                                <OpenInNewIcon />
                                            </IconButton>
                                        </Typography>
                                        <TextField

                                            id={value.id}
                                            // label="番号"
                                            type="text"
                                            onClick={this.url}
                                            value={"https://rooms.global-center.co.jp/rent/" + this.props.responsedetail.response_code + "/" + value.id + "/"}
                                            style={{ width: "100%" }}
                                            InputLabelProps={{
                                            shrink: true,
                                            }}
                                        />
                                        {/* {parseInt(this.state.tooltipOpen)} */}
                                        <Tooltip title="コピーしました！" open={parseInt(this.state.tooltipOpen) === value.id ? true : false}>
                                            <div></div>
                                        </Tooltip>
                                    </CardContent>
                                    
                                </Card>
                            );

        
                        }):""}
                        </RadioGroup>
                        </Scrollbars>

                            <Button disabled={!(parseInt(this.state.mypage_id) > 0)} color="danger" style={{ margin: "20px", marginTop: "10px" }} onClick={()=>{this.send_mypage_url();this.toggle_send(0)}} >送信する</Button>
                            <Button color="secondary" style={{ margin: "20px", marginTop: "10px" }} onClick={() => this.toggle_send(0)}>キャンセル</Button>

                        </div>

                    </div> : ""
                    }


                    {this.props.line_send_modal === 4 ? <div style={{ position: "absolute", zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "100%", height: "100%", marginLeft: -15, marginTop: -30 }}>

                        <div className="line_mypage" style={{ margin: "auto", marginTop: 50, borderRadius: "10px", width: "400px", height: "450px", padding: "20px", background: "#FFF", textAlign:"left" }}>
                            申込フォーム送信
                            <TextField
                                id="outlined-multiline-flexible"
                                label="内容"
                                multiline
                                minRows={10}
                                maxRows={10}
                                name="remarks"
                                onChange={this.OnChangeApplication}
                                value={this.state.application_remarks}
                                variant="outlined"
                                fullWidth
                                style={{ marginTop:10 }}
                            />

                            <TextField
                                label="申込フォーム"
                                size="small"
                                type="text"
                                disabled={true}
                                value={"https://rent.global-center.co.jp/mypage/apply/"+this.props.responsedetail.contract_code}
                                style={{ width: "100%", marginTop:10 }}
                                InputLabelProps={{
                                shrink: true,
                                }}
                            />

                            <TextField
                                label="パスワード"
                                size="small"
                                type="text"
                                disabled={true}
                                value={this.props.responsedetail.application_password_contract}
                                style={{ width: "150px", marginTop:10 }}
                                InputLabelProps={{
                                shrink: true,
                                }}
                            />

                            <TextField
                                label="申込期限"
                                size="small"
                                type="date"
                                disabled={true}
                                value={moment(this.props.responsedetail.application_limit_at_contract).format("YYYY-MM-DD")}
                                style={{ width: "200px", marginTop:10, marginLeft:5 }}
                                InputLabelProps={{
                                shrink: true,
                                }}
                            />
{/* 
                        <Scrollbars style={{height:350, padding:3 }}>


                        </Scrollbars> */}
                            <Box style={{textAlign:"center", paddingTop:20}}>
                                <Button disabled={this.state.application_remarks == ""} color="danger" style={{ }} onClick={()=>{this.send_application_url();this.toggle_send(0)}} >送信する</Button>
                                <Button color="secondary" style={{ marginLeft: "20px" }} onClick={() => this.toggle_send(0)}>キャンセル</Button>
                            </Box>
                        </div>

                    </div> : ""
                    }

                    {this.props.line_send_modal === 5 ? <div style={{ position: "absolute", zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "100%", height: "100%", marginLeft: -15, marginTop: -30 }}>

                        <div className="line_mypage" style={{ margin: "auto", marginTop: 50, borderRadius: "10px", width: "400px", height: "450px", padding: "20px", background: "#FFF", textAlign:"left" }}>
                            口座振替フォーム送信
                            <TextField
                                id="outlined-multiline-flexible"
                                label="内容"
                                multiline
                                minRows={10}
                                maxRows={10}
                                name="remarks"
                                onChange={this.OnChangeApplication}
                                value={this.state.application_remarks}
                                variant="outlined"
                                fullWidth
                                style={{ marginTop:10 }}
                            />

                            <TextField
                                label="口座振替フォーム"
                                size="small"
                                type="text"
                                disabled={true}
                                value={"https://rooms.global-center.co.jp/transfer/confirm/"+this.props.responsedetail.contract_code}
                                style={{ width: "100%", marginTop:10 }}
                                InputLabelProps={{
                                shrink: true,
                                }}
                            />

                            <TextField
                                label="パスワード"
                                size="small"
                                type="text"
                                disabled={true}
                                value={this.props.responsedetail.application_password_contract}
                                style={{ width: "150px", marginTop:10 }}
                                InputLabelProps={{
                                shrink: true,
                                }}
                            />

                            <Box style={{textAlign:"center", paddingTop:20}}>
                                <Button disabled={this.state.application_remarks == ""} color="danger" style={{ }} onClick={()=>{this.send_transfer_url();this.toggle_send(0)}} >送信する</Button>
                                <Button color="secondary" style={{ marginLeft: "20px" }} onClick={() => this.toggle_send(0)}>キャンセル</Button>
                            </Box>
                        </div>

                    </div> : ""
                    }

                    {this.props.line_send_modal === 6 ? <div style={{ position: "absolute", zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "100%", height: "100%", marginLeft: -15, marginTop: -30 }}>

                        <div className="line_mypage" style={{ margin: "auto", marginTop: 50, borderRadius: "10px", width: "520px", minHeight: "220px", padding: "20px", background: "#FFF", textAlign:"left" }}>
                            <div style={{ textAlign: "center" }}>ビデオ通話</div>
                            <div style={{ marginTop: 20 }}>
                                {webVideoCallUrl ? <>
                                    <Button color="primary" onClick={this.open_web_video_call_window}>
                                        <VideocamIcon style={{ fontSize: 18, marginRight: 4, marginTop: -2 }} />
                                        ビデオ通話画面へ
                                    </Button>
                                    <Tooltip title="コピーしました！" open={this.state.webVideoCallTooltipOpen}>
                                        <div style={{ marginTop: 15 }}>
                                            <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.6)", marginBottom: 4 }}>ビデオ通話リンク</div>
                                            <div
                                                id="web-video-call-url"
                                                onClick={this.copy_web_video_call_url}
                                                style={{
                                                    width: "100%",
                                                    paddingBottom: 6,
                                                    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                                                    color: "#1976d2",
                                                    cursor: "pointer",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}
                                            >
                                                {webVideoCallUrl}
                                            </div>
                                        </div>
                                    </Tooltip>
                                </> : "ビデオ通話リンクはまだありません。"}
                            </div>

                            <Scrollbars style={{height:320, padding:3, marginTop: 20 }}>




                                <TextField
                                    label="タイトル"
                                    name="topic"
                                    size="small"
                                    type="text"
                                    onChange={this.onChangeWebVideoCallForm}
                                    value={webVideoCallForm.topic}
                                    fullWidth
                                    style={{ marginTop:10 }}
                                    InputLabelProps={{ shrink: true }}
                                />
                                <Box style={{ display: "flex", gap: 10, marginTop: 10 }}>
                                    <TextField
                                        label="予約日"
                                        name="reservation_at"
                                        size="small"
                                        type="datetime-local"
                                        onChange={this.onChangeWebVideoCallForm}
                                        value={webVideoCallForm.reservation_at}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        label="有効期限"
                                        name="limited_at"
                                        size="small"
                                        type="datetime-local"
                                        onChange={this.onChangeWebVideoCallForm}
                                        value={webVideoCallForm.limited_at}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>

                                <TextField
                                    label="備考"
                                    name="remarks"
                                    size="small"
                                    type="text"
                                    multiline
                                    minRows={4}
                                    onChange={this.onChangeWebVideoCallForm}
                                    value={webVideoCallForm.remarks}
                                    fullWidth
                                    style={{ marginTop:10 }}
                                    InputLabelProps={{ shrink: true }}
                                />
                                <Box style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:12, gap:12 }}>
                                    <div style={{ minHeight: 20, fontSize: 12, color: "#d32f2f" }}>
                                        {webVideoCallUrl && this.state.webVideoCallDirty ? "未保存の変更があります" : ""}
                                    </div>
                                    {webVideoCallUrl ? <Button color="primary" onClick={this.save_web_video_call_reservations}>更新</Button>
                                    :<Button color="primary" onClick={this.create_web_video_call_reservations}>ビデオ通話リンクを作成する</Button>}
                                </Box>

                            </Scrollbars>

                            <Box style={{textAlign:"center", paddingTop:20}}>
                                <Button onClick={this.confirm_send_video_url} color="danger" style={{ marginRight: "20px" }} disabled={!webVideoCallUrl}>送信する</Button>
                                <Button color="secondary" onClick={() => this.toggle_send(0)}>閉じる</Button>
                            </Box>
                        </div>

                    </div> : ""
                    }


                    {this.props.line_looked_modal ? <div style={{ position: "absolute", zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "calc(100% - 17px)", height: "calc(100% - 10px)", marginLeft: -15, marginTop: -30 }}>

                        <div style={{ margin: "auto", marginTop: 50, borderRadius: "10px", width: "400px", height: "300px", padding: "20px", background: "#FFF" }}>
                            LINEを既読にしますか？

                            <div>
                                <Button color="danger" style={{ margin: "20px", marginTop: "50px" }} onClick={this.props.update_line_looked} >既読にする</Button>
                                <Button color="secondary" style={{ margin: "20px", marginTop: "50px" }} onClick={() => this.props.change_line_looked_modal(false)}>キャンセル</Button>
                            </div>
                        </div>

                    </div> : ""
                    }

                    <LineDispComponent />
                    <div style={{ float: "left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>

                    {/* {this.props.line_open_flg ? <div className="linebottom">
                        <LineFormComponent onSubmit={this.send} get_line_close={this.props.get_line_close} toggle_send={this.toggle_send} />

                    </div> : <div><div style={{ position: "absolute", bottom: "10px", right: "10px" }}>{this.props.responsedetail.intended_rent_m_response_status_id === 12 ? <Fab variant="extended" size="small" style={{ marginRight: "10px" }} onClick={() => this.props.change_line_looked_modal(true)}>
                        <VisibilityIcon color="primary" style={{ fontSize: "20px" }} />
                    </Fab> : ""} <Fab variant="extended" size="small" style={{ marginRight: "10px" }} onClick={this.lineopen}>
                            <i class="fab fa-line" style={{ fontSize: "20px", color: "green" }}></i>

                        </Fab></div>
                        <div style={{ position: "absolute", bottom: "10px", left: "10px" }}>
                            <Tooltip title="LINE解除"><Fab variant="extended" size="small" style={{ marginRight: "10px" }} onClick={this.togglesheet}>
                                <CancelIcon color="primary" style={{ fontSize: "20px" }} /></Fab></Tooltip>
                        </div>
                    </div>} */}

                    <Modal isOpen={this.state.modalsheet} toggle={this.togglesheet} fade={false}>

                        <ModalBody>
                            <div style={{ fontWeight: "bold" }}>LINEの結び付けを解除しますが、よろしいですか？</div>
                            <div style={{ marginTop: 10 }}>※解除すると、反響登録されていないLINEアカウントとして追客リストに表示されます。</div>
                        </ModalBody>
                        <ModalFooter>
                            <MuiButton variant="contained" color="secondary" onClick={() => this.props.delete_line_link()}>はい</MuiButton>
                            <MuiButton variant="contained" style={{ marginLeft: 3 }} onClick={this.togglesheet}>いいえ</MuiButton>
                        </ModalFooter>

                    </Modal>

                </div >
                <Box sx={{flex: 0.1, backgroundColor: "#ffffff", padding: 1, borderTop: "1px solid #ddd"}}>
                    <LineFormComponent onSubmit={this.send} row={this.state.row} get_line_close={this.props.get_line_close} toggle_send={this.toggle_send} />
                </Box>
            </Box>
        );
    }
}


//コンテナ
const mapStateToProps = state => {
    return {

        responsedetail: state.responsesReducer.responsedetail,
        lines: state.line.lines,
        line_bottom: state.line.line_bottom,
        line_user_details: state.line.line_user_details,
        line_open_flg: state.line.line_open_flg,
        line_send_modal: state.line.line_send_modal,
        line_send_file_loading: state.line.line_send_file_loading,
        line_send_list_loading: state.line.line_send_list_loading,
        line_looked_modal: state.line.line_looked_modal,
        rent_introduction_headers_list: state.mapmypage.rent_introduction_headers_list,
        rent_contract_details: state.contracts.rent_contract_details,
        contract_follow_editer: state.contractfollow.contract_follow_editer,
        web_video_call_reservations: state.responsesReducer.web_video_call_reservations
        //firebasetoken: state.firebaseReducer.firebasetoken,
        //firebasedata: state.firebaseReducer.firebasedata,
    }
}
function mapDispatchToProps(dispatch) {
    return {
        // change_mail_new_success(state) {
        //    dispatch(Mail.change_mail_new_success(state))
        // },
        send_message(state) {
            dispatch(Line.send_message(state))
        },
        send_mypage(state) {
            dispatch(Line.send_mypage(state))
        },
        send_video(state) {
            dispatch(Line.send_video(state))
        },
        send_application_form(state) {
            dispatch(Line.send_application_form(state))
        },
        send_transfer_form(state) {
            dispatch(Line.send_transfer_form(state))
        },
        get_lines(state) {
            dispatch(Line.get_lines(state))
        },
        get_lines_success(state) {
            dispatch(Line.get_lines_success(state))
        },
        change_line_bottom(state) {
            dispatch(Line.change_line_bottom(state))
        },
        get_line_close(state) {
            dispatch(Line.get_line_close(state))
        },
        get_line_open(state) {
            dispatch(Line.get_line_open(state))
        },
        send_line_stock_rooms(state) {
            dispatch(Line.send_line_stock_rooms(state))
        },
        change_line_file_data(state) {
            dispatch(Line.change_line_file_data(state))
        },
        upload_line_file(state) {
            dispatch(Line.upload_line_file(state))
        },
        change_line_send_modal(state) {
            dispatch(Line.change_line_send_modal(state))
        },
        change_line_looked_modal(state) {
            dispatch(Line.change_line_looked_modal(state))
        },
        update_line_looked(state) {
            dispatch(Line.update_line_looked(state))
        },
        get_fire_line_detail(state) {
            dispatch(Firebase.get_fire_line_detail(state))
        },
        delete_line_link(state) {
            dispatch(Line.delete_line_link(state))
        },
        get_rent_introduction_headers_list(state) {
            dispatch(IntroductionListEdit.get_rent_introduction_headers_list(state))
        },
        get_web_video_call_reservations(state) {
            dispatch(Responses.get_web_video_call_reservations(state))
        },
        change_web_video_call_reservations(state) {
            dispatch(Responses.change_web_video_call_reservations(state))
        },
        update_web_video_call_reservations(state) {
            dispatch(Responses.update_web_video_call_reservations(state))
        },
        insert_web_video_call_reservations(state) {
            dispatch(Responses.insert_web_video_call_reservations(state))
        },
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(Lines);
